'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _Playlists = require('helpers/Playlists');

var _AlbumListItem = require('components/AlbumItem/AlbumListItem/AlbumListItem');

var _AlbumListItem2 = _interopRequireDefault(_AlbumListItem);

var _AlbumGridItem = require('components/AlbumItem/AlbumGridItem/AlbumGridItem');

var _AlbumGridItem2 = _interopRequireDefault(_AlbumGridItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlaylistsItem = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    deletePlaylistActionData: state.playlists.deletePlaylistActionData,
    deletePlaylistLoading: state.playlists.deletePlaylistLoading,
    viewType: state.playlists.viewType
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlaylistsItem, _Component);

  function PlaylistsItem() {
    (0, _classCallCheck3.default)(this, PlaylistsItem);
    return (0, _possibleConstructorReturn3.default)(this, (PlaylistsItem.__proto__ || (0, _getPrototypeOf2.default)(PlaylistsItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlaylistsItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          viewType = _props.viewType,
          album = _props.album,
          deletePlaylistActionData = _props.deletePlaylistActionData,
          deletePlaylistLoading = _props.deletePlaylistLoading,
          coloredInfo = _props.coloredInfo,
          tracks = _props.tracks;

      var loading = deletePlaylistLoading && deletePlaylistActionData.key === album.contentKey;

      return viewType === _Playlists.viewTypes.grid ? _react2.default.createElement(_AlbumGridItem2.default, {
        album: album,
        tracks: tracks,
        coloredInfo: coloredInfo,
        loading: loading
      }) : _react2.default.createElement(_AlbumListItem2.default, {
        album: album,
        tracks: tracks,
        coloredInfo: coloredInfo,
        loading: loading
      });
    }
  }]);
  return PlaylistsItem;
}(_react.Component), _class2.propTypes = {
  album: _propTypes2.default.object,
  coloredInfo: _propTypes2.default.bool,
  deletePlaylistActionData: _propTypes2.default.object,
  deletePlaylistLoading: _propTypes2.default.bool,
  tracks: _propTypes2.default.object,
  viewType: _propTypes2.default.string
}, _class2.defaultProps = {
  album: {},
  tracks: {}
}, _temp)) || _class);
exports.default = PlaylistsItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlists/components/PlaylistsItem/PlaylistsItem.js
// module id = 2183
// module chunks = 1